import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, authorisationConverter, useFetchUserData } from '../../utils/AppFunctions'

import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import { MdAdd, MdCheck } from 'react-icons/md';
import { tidy_date, tidy_date_raw, tidy_frequency_name, tidy_time_difference } from '../../utils/helper';
import notify from '../../utils/IANotification';
import { get_all_user_published_prayer, pray_for_prayer } from '../../api/prayerAPI';
import DataTable from '../../components/ui/DataTable';
import Button from '../../components/ui/Button';

export default function PrayerSupportPage() {
  const navigate = useNavigate()
  const { isAuthorised, userRole } = useFetchAuthorisation("user")
  let user_data = useFetchUserData()

  const [prayerListData, setPrayerListData] = useState([])
  const [loading, setLoading] = useState(true)
  const [query, setQuery] = useState("")

  useEffect(() => {
    fetchPrayerList()
  }, [])

  const fetchPrayerList = async () => {
    setLoading(true);
    try {
      const data = await get_all_user_published_prayer();
      if (data?.status === 200) {
        setPrayerListData(data.data);
      }
    } catch (err) {
      // Optionally handle error
    }
    setLoading(false);
  }


  const prayForPrayer = async (prayer_id) => {
    if (!prayer_id) return null;
    try {
      const data = await pray_for_prayer(prayer_id);
      if (data?.status === 200) {
        fetchPrayerList();
        notify({ message: "Saved", type: "success" });
      } else {
        notify({ message: "Unable", type: "error" });
      }
    } catch (err) {
      notify({ message: "Unable", type: "error" });
    }
  }
  const table_columns = [
    {
      header: "Created At",
      accessor: "createdAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    },
    {
      header: "Prayers Count",
      accessor: "prayers_count",
      modifier: (data) => `${data.length} times`
    },
    {
      header: "Content",
      accessor: "content"
    },
      {
      header: "Testimony",
      accessor: "testimony"
    },
    {
      header: "Last Updated",
      accessor: "updatedAt",
      modifier: (data) => `${tidy_date(data)} (${tidy_time_difference(data)})`
    }
  ]


  return (
    <AdminLayout
      navSelected={"Prayer Support"}
      toolbar={
        <>
          <h1 className='text-lg font-semibold text-gray-900'>Prayer Support</h1>
        </>
      }
    >
      {/* <div className="column items-center justify-between w-100 mb-40">
        <input
          type="text"
          placeholder="Search..."
          className='text-input w-100'
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
        />
      </div> */}

      {loading ? (
        <div className="flex-row items-center flex justifyCenter w-100">
          <h1>Loading...</h1>
        </div>
      ) : (
        <div className="w-100">
          {/* {prayerListData.map((prayer, index) => {
            if (!JSON.stringify(prayer).toLowerCase().includes(query.toLowerCase())) return null
            return (
              <div
                key={index}
                className="flex-row flex alignStart justify-between w-100 card mt-10"
              >
                <div className="">
                  <h3 className='card-subtitle gray'>praying since {tidy_date(prayer.createdAt)}  |  {prayer?.prayers_count?.length} times</h3>
                  <h3 style={{ color: prayer?.is_answered == 1 ? "gray" : "black" }}>{prayer.content}</h3>
                  {prayer?.is_answered == 1 &&
                    <div style={{ marginTop: 10, paddingTop: 10, borderTop: "1px solid gray" }}>
                      <p className="small gray">Testimony</p>
                      <h3 style={{}}>{prayer.testimony}</h3>
                    </div>}
                </div>
                {prayer?.is_answered == 0 ? <button
                  className="button"
                  onClick={() => {
                    prayForPrayer(prayer.id)
                  }}
                >
                  Pray
                </button>
                  :
                  <p style={{ padding: "5px 10px", borderRadius: 15, backgroundColor: "yellowgreen", color: "black", fontSize: 12 }}>Answered</p>
                }

              </div>
            )
          })} */}
          <DataTable
            columns={table_columns}
            data={prayerListData}
            enableActions
            actions={(row) => {
              return (
                <div className="flex gap-2">
                  {row?.is_answered == 0 && (
                    <Button
                      variant="outline"
                      size="sm"
                      icon={MdCheck}
                      onClick={() => {
                        prayForPrayer(row.id)
                      }}
                    >
                      Pray
                    </Button>
                  )}
                </div>
              )
            }}
          />
        </div>
      )}
    </AdminLayout>
  )
}
